// app/src/features/signals/SignalBar.jsx
import React from "react";
import IndicesBar from "../../components/IndicesBar.jsx";
import { recordUiEvent } from "../../lib/logRingBuffer";

/**
 * The indices bar under the timeline column (the frame's `signalBar` slot): the plotted signals'
 * chips, the Signal Library drawer toggle and the settings / account / bug controls. Nothing
 * without an active forecast.
 *
 * With the rail it closes the timeline column, so the rail and its panels stand in front of it;
 * the classic layout keeps it full width under everything.
 */
export default function SignalBar({ ctx }) {
  const {
    active,
    theme,
    series,
    removeSeries,
    addSeries,
    proOpen,
    setProOpen,
    setAccountOpen,
    proColors,
    accountOpen,
    openBugReport,
    showReport,
    pendingPreprocess,
    railPanelOpen,
    bugFlash,
    tsDrawerOpen,
    setTsDrawerOpen,
    tsdH,
    setTsdH,
  } = ctx;
  return active ? (
    <IndicesBar
      theme={theme}
      series={series}
      onRemove={removeSeries}
      onAdd={addSeries}
      settingsOpen={proOpen}
      onSettingsToggle={() => {
        setProOpen((v) => !v);
        setAccountOpen(false);
      }}
      proColors={proColors}
      onAccountToggle={() => {
        setAccountOpen((v) => {
          recordUiEvent({ event: "ui.account.toggle", open: !v });
          return !v;
        });
        setProOpen(false);
      }}
      accountOpen={accountOpen}
      onBugReport={openBugReport}
      // The report and the preprocess-confirmation panel render at z400, above the bar (z63),
      // which would put the bug / settings / account icons under a dimming backdrop. The bar is
      // lifted over them so the icons stay full-strength and clickable; the bug modal is z600, so
      // it still lands on top. Everything on the bar EXCEPT the icons goes inert while lifted
      // (see IndicesBar), so a stray click on the strip does not open the time-series drawer over
      // the panel.
      liftedOverIcons={showReport || !!pendingPreprocess}
      inColumn
      leftInset={railPanelOpen ? "var(--rail-panel-w)" : 0}
      bugFlash={bugFlash}
      hideUtilityIcons
      tsDrawerOpen={tsDrawerOpen}
      onTsDrawerToggle={() =>
        setTsDrawerOpen((v) => {
          // Closing the drawer FROM a lifted state (was open AND tsdH===0):
          // instantly expand the TSD chart to 25vh (no transition — tsdAnimating
          // stays false) so the chart fills the space behind the still-closing
          // drawer. The axis+handle strip stays anchored at its lifted position
          // because its render Y (bottom:32 + tsdH) is unchanged across the
          // toggle. The user only sees the drawer slide down; nothing else moves.
          if (v && tsdH === 0) setTsdH(Math.round(window.innerHeight * 0.25));
          return !v;
        })
      }
    />
  ) : null;
}
